export const LICENSE_CONSUME_LICENSE = 'license_consume_license';
export const LICENSE_RECEIVED_CONSUME_LICENSE = 'license_receive_consume_license';

export const LICENSE_GET_LICENSE_REPORT = 'license_get_license_report';
export const LICENSE_RECEIVED_GET_LICENSE_REPORT = 'license_received_get_license_report';
export const LICENSE_GET_LICENSE_REPORT_LIST = 'license_get_license_report_list';
export const LICENSE_RECEIVED_GET_LICENSE_REPORT_LIST = 'license_received_get_license_report_list';

export const LICENSE_UPDATE_LICENSES = 'license_update_licenses';
export const LICENSE_RECEIVED_UPDATE_LICENSES = 'license_received_update_licenses';